export default __webpack_public_path__ + "static/media/IMG_022_finished_bw.ae064600.jpg";